"use strict";
import { getNativeAddress } from "constants/uniswapAddresses";
import { getChainInfo } from "features/chains/chainInfo";
import { toSupportedChainId } from "features/chains/utils";
import { wrappedNativeCurrency } from "utils/currency";
export class NativeCurrency {
  constructor(chainId) {
    const supportedChainId = toSupportedChainId(chainId);
    if (!supportedChainId) {
      throw new Error(`Unsupported chain ID: ${chainId}`);
    }
    const { nativeCurrency } = getChainInfo(supportedChainId);
    this.chainId = supportedChainId;
    this.decimals = nativeCurrency.decimals;
    this.name = nativeCurrency.name;
    this.symbol = nativeCurrency.symbol;
    this.isNative = true;
    this.isToken = false;
    this.address = getNativeAddress(this.chainId);
  }
  chainId;
  decimals;
  name;
  symbol;
  isNative;
  isToken;
  address;
  equals(currency) {
    return currency.isNative && currency.chainId === this.chainId;
  }
  get wrapped() {
    return wrappedNativeCurrency(this.chainId);
  }
  static _cachedNativeCurrency = {};
  static onChain(chainId) {
    return this._cachedNativeCurrency[chainId] ?? (this._cachedNativeCurrency[chainId] = new NativeCurrency(chainId));
  }
}
